/*
 * O item de atividade do perfil: avatar de 48px, o título do tópico como
 * link, categoria e data embaixo e o começo do texto. Usado pelas abas de
 * postagens do perfil (Postagens, Curtidas, Menções, Votos, Resolvido) e pela
 * aba Reações, que acrescenta a linha da reação (`extra`).
 */
import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';
import { truncate } from 'flarum/common/utils/string';
import { discussionBadges } from '../utils/tags';
import { fullDate, mediumAge } from '../utils/dates';

/** O tamanho do trecho (o resumo do post). */
const STREAM_EXCERPT = 300;
export default function streamItem(post, options = {}) {
  const discussion = post.discussion();
  const user = post.user();
  const createdAt = post.createdAt();
  return m("div", {
    className: classList('PostListItem CanelaStreamItem', options.className)
  }, m("div", {
    className: "CanelaStreamItem-header"
  }, user ? m(Link, {
    href: app.route.user(user),
    className: "CanelaStreamItem-avatar",
    tabindex: "-1",
    "aria-hidden": "true"
  }, m(Avatar, {
    user: user
  })) : m("span", {
    className: "CanelaStreamItem-avatar"
  }, m(Avatar, {
    user: null
  })), m("div", {
    className: "CanelaStreamItem-details"
  }, m("div", {
    className: "CanelaStreamItem-title"
  }, m(Link, {
    href: app.route.post(post)
  }, discussion ? discussion.title() : '')), m("div", {
    className: "CanelaStreamItem-meta"
  }, discussion && discussionBadges(discussion), createdAt && m("time", {
    className: "CanelaStreamItem-date",
    datetime: createdAt.toISOString(),
    title: fullDate(createdAt)
  }, mediumAge(createdAt))))), options.extra, m("div", {
    className: "CanelaStreamItem-excerpt"
  }, truncate(post.contentPlain() || '', STREAM_EXCERPT)));
}
flarum.reg.add('ramon-canela', 'forum/user/streamItem', streamItem);